import { useQuery } from "@tanstack/react-query";
import apiClient from "lib/api-client";

export const getActiveCatalogs = [
  {
    catalogName: "Gents Bracelets",
    catalogNumber: "#560852",
    designCount: 6,
    expiryDateAndTime: "8th Jan 2025, 1:56 PM",
    createdBy: "Sneh Patel",
    createdAt: "05 Dec 2024, 1:56 PM",
    _id: "6763c1af907909664dbefb9b",
  },
  {
    catalogName: "New Feel",
    catalogNumber: "#396",
    designCount: 7,
    expiryDateAndTime: "14th Feb 2025, 4:55 PM",
    createdBy: " Ayan Qureshi",
    createdAt: "05 June 2024, 1:56 PM",
    _id: "6763c1af907909664dbefb9b",
  },
  {
    catalogName: "Cool",
    catalogNumber: "#560852",
    designCount: 9,
    expiryDateAndTime: "23rd Mar 2025, 2:11 PM",
    createdBy: "Sneh Patel",
    createdAt: "05 Dec 2024, 1:56 PM",
    _id: "6763c1af907909664dbefb9b",
  },
];

export const getExpiryCatalogs = [
  {
    catalogName: "Gents Bracelets",
    catalogNumber: "#560852",
    designCount: 6,
    createdBy: "Sneh Patel",
    createdAt: "05 June 2024, 1:56 PM",
    _id: "6763c1af907909664dbefb9b",
  },
  {
    catalogName: "New Feel",
    catalogNumber: "#396",
    designCount: 11,
    createdBy: " Ayan Qureshi",
    createdAt: "05 June 2024, 1:56 PM",
    _id: "6763c1af907909664dbefb9b",
  },
  {
    catalogName: "Cool",
    catalogNumber: "#560852",
    designCount: 7,
    createdBy: "Sneh Patel",
    createdAt: "05 Dec 2024, 1:56 PM",
    _id: "6763c1af907909664dbefb9b",
  },

  {
    catalogName: "Tanish Catalog",
    catalogNumber: "#560894",
    designCount: 5,
    createdBy: "Sneh Patel",
    createdAt: "05 June 2024, 1:56 PM",
    _id: "6763c1af907909664dbefb9b",
  },
  {
    catalogName: "Gents Bracelets",
    catalogNumber: "#560852",
    designCount: 13,
    createdBy: "Sneh Patel",
    createdAt: "05 June 2024, 1:56 PM",
    _id: "6763c1af907909664dbefb9b",
  },
];

// import { fetchActiveCatalogs, fetchExpiredCatalogs } from "../api/catalog.api";

const fetchActiveExpiredCatalogs = async (payload) => {
  // console.log("fetchActiveExpiredCatalogs payload---->", payload);

  let data = await apiClient.post(`/api/v9/myBinnys/getClientCatalogData`, payload);

  return data.data.data;
};

export const useCatalogs = ({ isActiveCatalog, clientCode }) => {
  return useQuery({
    queryKey: ["catalogs", isActiveCatalog, clientCode],
    queryFn: () => fetchActiveExpiredCatalogs({ isActiveCatalog, clientCode }),
    enabled: Boolean(clientCode),
    keepPreviousData: true,
  });
};

//---- sesison api

const fetchExpiredCatalogSessions = async (payload) => {
  // console.log("fetchExpiredCatalogSessions payload---->", payload);
  const { data } = await apiClient.post("/api/v9/myBinnys/getExpiredCatalogSessions", payload);
  return data?.data?.expiredSessions || [];
};

export const useExpiredCatalogSessions = ({ clientCode, catalogId }) => {
  return useQuery({
    queryKey: ["expiredCatalogSessions", clientCode, catalogId],
    queryFn: () =>
      fetchExpiredCatalogSessions({
        clientCode,
        catalogId,
      }),
    enabled: !!clientCode && !!catalogId, // avoid unwanted calls
    keepPreviousData: true,
  });
};
